/** Prefixes every Amplify token key so Reports tokens do not collide with
 *  tokens written by the Admin or Insights SPAs on the shared parent origin. */
export class SpaKeyValueStorage {
  constructor(private readonly _prefix: string) {}

  async setItem(key: string, value: string): Promise<void> {
    localStorage.setItem(this._prefix + key, value);
  }

  async getItem(key: string): Promise<string | null> {
    return localStorage.getItem(this._prefix + key);
  }

  async removeItem(key: string): Promise<void> {
    localStorage.removeItem(this._prefix + key);
  }

  async clear(): Promise<void> {
    const toRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k?.startsWith(this._prefix)) toRemove.push(k);
    }
    toRemove.forEach((k) => localStorage.removeItem(k));
  }
}
